// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".how-to-start[data-v-c04838ae]{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:80px 16px;gap:32px}.how-to-start__player[data-v-c04838ae]{position:relative;overflow:hidden;max-width:1120px;width:100%;aspect-ratio:16 / 9;margin:0 auto}.how-to-start__player-iframe[data-v-c04838ae]{position:absolute;border-radius:16px;top:0;left:0;bottom:0;right:0;width:100%;height:100%}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
